// extracted by css-extract-rspack-plugin
export default {"contentContainer":"AlertModalSettingsBlock-module__contentContainer___PfgqU"};